import { createSelector } from 'reselect'
import currentUserRolesSelector from 'selectors/currentUserRoles'

export default createSelector(
  [
    currentUserRolesSelector,
  ],
  (
    currentUserRoles,
  ) => ({
    currentUserRoles,
  })
)
